import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  validationRequiredEmail: {
    id: 'components.forgot.validation.required.email',
    defaultMessage: 'Email is a required field',
  },
  validationEmail: {
    id: 'components.forgot.validation.email',
    defaultMessage: 'This must be a valid email address',
  },
  placeholderEmail: {
    id: 'components.forgot.form.placeholder.email',
    defaultMessage: 'Email',
  },
  forgotButton: {
    id: 'components.forgot.form.forgotButton',
    defaultMessage: 'Submit',
  },
  successText: {
    id: 'components.signup.form.successText',
    defaultMessage: 'A verification email has been sent to <strong>{email}</strong>. Please click to the link to activate your referral account on our site.',
  },
});



// WEBPACK FOOTER //
// ./src/components/Forgot/messages.js